import { forwardRef } from 'react'

import ReactSelect from 'react-select'
import { useTranslation } from 'react-i18next'

type Props = {
  placeholder?: string
  isDisabled?: boolean
  isError?: boolean
  isSearchable?: boolean
  containerClassName?: string
  errorMessage?: string
  translateLabel?: boolean
  [key: string]: unknown
} & Omit<React.ComponentProps<typeof ReactSelect>, 'styles'>

export const Select = forwardRef<never, Props>(
  (
    {
      errorMessage,
      variant = 'white',
      placeholder = '',
      isDisabled = false,
      isSearchable = false,
      isError = false,
      translateLabel = true,
      containerClassName,
      size = 'lg',
      ...restProps
    }: Props,
    ref,
  ) => {
    const { t } = useTranslation()

    return (
      <div className={containerClassName}>
        <ReactSelect
          ref={ref}
          placeholder={placeholder}
          isSearchable={isSearchable}
          isDisabled={isDisabled}
          styles={{
            control: (baseStyles: any) => ({
              ...baseStyles,
              borderRadius: '8px',
              border: isError ? '1px solid #DC2626' : '1px solid #E2E2E2',
              background: '#fff',
              height: '50px',
              paddingRight: '10px',
              paddingLeft: '12px',
              boxShadow: 'none',
              transition: 'border 0.3s',
              '&:hover, &:focus-within': {
                outline: 'none',
                border: '1px solid #0C75FF',
              },
            }),
            singleValue: (baseStyles: any) => ({
              ...baseStyles,
              color: '#000',
            }),
            menu: (baseStyles: any) => ({
              ...baseStyles,
              padding: '0',
              margin: '5px 0 0 0',
              borderRadius: '8px',
              borderWidth: '1px',
              background: '#fff',
              borderColor: '#E2E2E2',
            }),
            menuList: (baseStyles: any) => ({
              ...baseStyles,
              padding: '0',
            }),
            valueContainer: (baseStyles: any) => ({
              ...baseStyles,
              fontSize: '16px',
              fontWeight: 500,
              textAlign: 'left',
              paddingLeft: '2px',
            }),
            option: (baseStyles: any) => ({
              ...baseStyles,
              backgroundColor: '#fff',
              borderRadius: '8px',
              color: '#000',
              transition: 'color 0.2s, background-color 0.2s',
              paddingLeft: '20px',
              fontSize: '16px',
              fontWeight: 400,
              textAlign: 'left',

              '&:hover': {
                backgroundColor: '#0C75FF',
                color: '#fff',
              },
            }),
            placeholder: (baseStyles: any) => ({
              ...baseStyles,
              color: '#000',
              fontSize: '16px',
              textAlign: 'left',
              fontWeight: 400,
            }),
            dropdownIndicator: (baseStyles: any) => ({
              ...baseStyles,
              color: '#0C75FF',
              '&:hover': {
                color: '#0C75FF',
              },
            }),
          }}
          components={{
            IndicatorSeparator: () => null,
          }}
          formatOptionLabel={(option: any) => {
            const { label } = option as { label: string }
            return translateLabel ? t(label) : label
          }}
          {...restProps}
        />

        {/*{isError && (*/}
        {/*  <p*/}
        {/*    className={`w-full mt-1 text-xs text-left ${isError ? 'text-red-600' : 'text-black '}`}*/}
        {/*  >*/}
        {/*    {t(errorMessage ?? 'errors.requiredField')}*/}
        {/*  </p>*/}
        {/*)}*/}
      </div>
    )
  },
)

Select.displayName = 'Select'
